<template>
  <div class="group_1 flex-col">
    <div class="group_2 flex-col">
      <div class="saerch">
        <van-search v-model="invitee" show-action placeholder="请输入名称">
          <template #action>
            <van-button type="primary" round @click="search">搜索</van-button>
          </template>
        </van-search>
      </div>

      <van-pull-refresh v-model="Loading" @refresh="onfresh">
        <div class="warmTips" v-if="List && !List.length && !loading">
          <img src="../../assets/images/404.png" />
          <span>没有更多内容了</span>
        </div>
        <div v-else class="list">
          <!-- <div style="text-align:center; padding:30px 0;position: fixed;top: 1.5rem;z-index: 999;"  >
          <van-overlay :show="loading"  :lock-scroll="true" style="z-index: 888;">
            <van-loading  color="#fff"  size="24px" vertical style="z-index: 999;margin-top: 50%;">加载中...</van-loading>
          </van-overlay>
        </div> -->
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
            :immediate-check="false">
            <div class="box_4 flex-col" v-for="(item, index) in List" :key="index">
              <div class="box_5 flex-row justify-between" @click="lookdetail(item)">
                <div>
                  <span class="text_12">{{ item.invitee }}</span>
                  <span class="text_20">{{item.memberCategory==1?'个人':'单位'}}</span>
                </div>
                <span class="text_13">{{item.invitationSuccessTime}}</span>

              </div>

              <van-divider />
            </div>

          </van-list>
        </div>
      </van-pull-refresh>
      <van-dialog title="详情" v-model="show" confirmButtonText="关闭">
        <div class="content">
          <div>
            <span>姓名</span>
            <span>{{detailItem.invitee}}</span>
          </div>
          <div>
            <span>会员编号</span>
            <span>{{detailItem.memberNo}}</span>
          </div>
          <div>
            <span>有效期</span>
            <span>{{detailItem.expiryDate| limitDate}}</span>
          </div>
          <div v-if="detailItem.company">
            <span>所在单位</span>
            <span>{{detailItem.company}}</span>
          </div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
  import { Icon, Loading, List, Toast, PullRefresh, Search, Button, Divider, Dialog } from "vant"

  import {
    invitationRecordPage,
    getUser
  } from "@/api/dictionary";
  export default {
    props: {
      type: {
        type: String,
      },
    },
    data() {
      return {
        constants: {},
        loading: false,
        Loading: false,
        finished: false,
        page: 0,
        show: false,
        invitee: '',
        userInfo: {},
        // type:'',
        List: [],
        detailItem: {},

      }
    },
    components: {
      [Icon.name]: Icon,
      [Loading.name]: Loading,
      [List.name]: List,
      [Toast.name]: Toast,
      [PullRefresh.name]: PullRefresh,
      [Search.name]: Search,
      [Button.name]: Button,
      [Divider.name]: Divider,
      [Dialog.Component.name]: Dialog.Component,

    },
    watch: {
      $route(to, from) {
        // 在mounted函数执行的方法，放到该处
        // this.page = -1
        // this.onLoad()
      },
    },
    methods: {
      refund() {
        alert(1)
      },
      lookdetail(item) {
        console.log("id", item.id)
        this.detailItem = item
        this.show = true
      },
      refuse(item) {
        console.log(item)
        // cancelRefundMeeting({ refundId: item.id }).then((res) => {
        //   if (res.success) {
        //     Toast.success("操作成功")
        //     this.$router.push({
        //       name: "meetingManagerList",
        //       query: { type: this.type },
        //     })
        //     this.onfresh()
        //   } else {
        //     Toast.fail("操作失败")
        //   }

        // sessionStorage.setItem("memberId", res.result.id);
        // })
      },
      search() {
        this.page = 0
        this.List = []
        let params = {
          inviterId: this.userInfo.userId,
          invitee: this.invitee
        }
        invitationRecordPage(params, this.page)
          .then((res) => {
            if (res.success) {
              if (res.result.content.length > 0) {
                this.List = res.result.content
              }
            }
          })
          .catch(() => {
            Toast.fail("获取数据失败")
          })
          .finally(() => {
            this.Loading = false
          })
      },
      onfresh() {
        this.page = 0
        this.List = []
        this.finished = false
        this.onLoad()
        this.Loading = false
        // let params = {
        //   inviterId: this.userInfo.userId,
        // }
        // invitationRecordPage(params, this.page)
        //   .then((res) => {
        //     if (res.success) {
        //       if (res.result.content.length > 0) {
        //         this.List = res.result.content
        //       }
        //     }
        //   })
        //   .catch(() => {
        //     Toast.fail("获取数据失败")
        //   })
        //   .finally(() => {
        //    
        //   })
      },
      onLoad() {
        console.log("aa", this.loading)
        // 异步更新数据
        if (this.finished == true) return
        let params = {
          inviterId: this.userInfo.userId,
          invitee: this.invitee
        }
        invitationRecordPage(params, this.page++)
          .then((res) => {
            if (res.success) {
              if (res.result.content.length > 0) {
                this.List.push(...res.result.content)
              }
            }
            this.loading = false
            if (this.List.length >= res.result.totalElements) {
              this.finished = true
            }
          })
          .catch(() => {
            Toast.fail("获取数据失败")
          })
          .finally(() => {
            this.loading = false
          })
      },
      getData() {
        // 异步更新数据
        console.log('a', this.loading)
        this.loading = true
        let params = {
          inviterId: this.userInfo.userId,
          invitee: this.invitee
        }
        invitationRecordPage(params, this.page)
          .then((res) => {
            this.loading = false
            if (res.success) {
              if (res.result.content.length > 0) {
                this.List.push(...res.result.content)
              }
              if (this.List.length >= res.result.totalElements) {
                this.finished = true
              }
            }
          })
          .catch(() => {
            Toast.fail("获取数据失败")
          })
          .finally(() => {
            this.loading = false
          })
      },
    },
    created() {
      getUser().then(res => {
        if (res.success) {
          this.userInfo = res.result;
          this.onLoad()

        }
      })

    },
    mounted() {
      // this.getData()

    },
  }
</script>
<style scoped lang="less">
  /deep/.van-list {
    margin-bottom: 50px;
    margin-top: 60px;
    height: 500px;
    overflow-y: scroll;
  }

  .saerch {
    position: fixed;
    z-index: 10;
    top: 40px;
    width: 95%;
    background: #fff;
  }

  .van-button {
    border-radius: 4px;
    background-color: rgba(248, 95, 37, 1);
    color: rgba(255, 255, 255, 1);
    border-color: rgba(248, 95, 37, 1);
    height: 35px;
  }

  .content {
    padding: 20px;
    height: 160px;

    div {
      padding-bottom: 15px;
      display: flex;
      align-items: flex-start;

      span:first-child {
        width: 70px;
        margin-right: 10px;

      }

      span:last-child {
        width: 200px;

      }

      span {
        display: inline-block;
        font-size: 16px;
        line-height: 20px;
      }
    }
  }

  .page {
    position: relative;
    overflow: hidden;
  }

  .warmTips {
    margin: 30px 0 0 0;
    padding-top: 45%;
  }

  .image-wrapper_1 {
    background-color: rgba(255, 255, 255, 1);
    padding: 18px 16px 13px 37px;
  }

  .group_1 {
    margin-top: 27px;
    padding: 0 8px 0 8px;
  }

  .box_4 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 5px 12px 0 16px;
    min-height: 15px;
  }

  .box_5 {
    width: 100%;
  }

  .text_12 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: NaN;
    text-align: left;
    line-height: 24px;
    margin-top: 1px;
  }


  .text_13 {
    overflow-wrap: break-word;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .section_3 {
    margin: 16px 0 0 0;
    justify-content: end;
  }

  .text-wrapper_4 {
    width: 90px;
    height: 24px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 24px;
    margin: 16px 280px 0 0;
  }

  .text_14 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 24px;
  }

  .text_15 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 24px;
  }

  .text-wrapper_5 {
    width: 280px;
    height: 24px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 24px;
    margin: 16px 90px 0 0;
  }

  .text_16 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 24px;
  }

  .text_17 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 24px;
  }

  .text-wrapper_6 {
    width: 135px;
    height: 24px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 24px;
    margin: 16px 235px 0 0;
  }

  .justify-between {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  .text_18 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 24px;
  }

  .text_19 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 24px;
  }

  .button_4 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 28px;
    border: 1px solid rgba(230, 230, 232, 1);
    margin: 0 16px 0 255px;
    padding: 5px 10px 4px 9px;
  }

  .text_20 {
    margin-left: 15px;
    display: inline-block;
    width: 36px;
    height: 20px;
    line-height: 20px;
    border-radius: 5px;
    color: rgba(248, 95, 37, 1);
    font-size: 12px;
    text-align: center;
    font-family: Roboto;
    border: 1px solid rgba(248, 95, 37, 1);
  }

  .box_6 {
    background-color: rgba(255, 89, 98, 0.054);
    margin-top: 16px;
    margin-left: -16px;
    padding: 10px 12px 7px 16px;
  }

  .icon_1 {
    background-color: rgba(255, 89, 98, 1);
    border-radius: 8px;
    width: 6px;
    padding: 2px 6px 2px 5px;
  }

  .text_21 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-family: JLinXin;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 12px;
  }

  .text_22 {
    width: 335px;
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 17px;
  }

  .button_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 28px;
    border: 1px solid rgba(250, 173, 122, 1);
    padding: 5px 15px 4px 15px;
    margin-right: 6px;
  }

  .button_3:active {
    background-color: rgba(246, 109, 17, 1);
    border-radius: 28px;
    padding: 5px 15px 4px 15px;
    margin-right: 6px;
  }

  .text_15 {
    overflow-wrap: break-word;
    color: rgba(250, 173, 122, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .text_15:active {
    color: #fff;
  }
</style>